import React, { Component } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import http from "../../Services/httpService";
import auth from "../../Services/authService";
import config from "../../config.json";

const SURVEY_STYLES = {
  pageWrap: {
    padding: "12px 0 4px 0"
  },
  shell: {
    borderRadius: "24px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    boxShadow: "0 18px 38px rgba(15, 23, 42, 0.06)",
    overflow: "hidden"
  },
  hero: {
    padding: "24px 24px 18px 24px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleWrap: {
    minWidth: 0,
    display: "flex",
    alignItems: "flex-start",
    gap: "14px"
  },
  titleIcon: {
    width: "52px",
    height: "52px",
    borderRadius: "16px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "24px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  titleCopy: {
    minWidth: 0
  },
  eyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "10px"
  },
  title: {
    fontSize: "24px",
    fontWeight: 800,
    lineHeight: 1.15,
    color: "#0f172a",
    margin: 0
  },
  subtitle: {
    fontSize: "14px",
    lineHeight: 1.6,
    color: "#475569",
    margin: "8px 0 0 0",
  },
  soonBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 14px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    backgroundColor: "#ffffff",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 8px 22px rgba(37, 99, 235, 0.08)"
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginTop: "18px"
  },
  statCard: {
    borderRadius: "18px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)"
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px"
  },
  statValue: {
    fontSize: "26px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1
  },
  statHint: {
    fontSize: "12px",
    lineHeight: 1.5,
    color: "#64748b",
    marginTop: "6px"
  },
  body: {
    padding: "20px 24px 24px 24px",
    display: "grid",
    gap: "18px"
  },
  sectionCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    overflow: "hidden"
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    padding: "16px 18px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(180deg, rgba(248, 250, 252, 0.98) 0%, rgba(255, 255, 255, 1) 100%)"
  },
  sectionTitle: {
    fontSize: "17px",
    fontWeight: 800,
    color: "#0f172a",
    margin: 0
  },
  sectionMeta: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "2px"
  },
  sectionBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "34px",
    height: "34px",
    padding: "0 12px",
    borderRadius: "999px",
    background: "rgba(37, 99, 235, 0.08)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 800
  },
  table: {
    marginBottom: 0
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px"
  },
  cell: {
    verticalAlign: "middle",
    padding: "16px"
  },
  serialBadge: {
    minWidth: "34px",
    height: "34px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4338ca",
    fontSize: "13px",
    fontWeight: 800
  },
  datePrimary: {
    display: "block",
    color: "#0f172a",
    fontSize: "14px",
    fontWeight: 700
  },
  dateSecondary: {
    display: "block",
    color: "#64748b",
    fontSize: "13px"
  },
  taskLink: {
    color: "#2563eb",
    fontWeight: 700,
    textDecoration: "none"
  },
  officerName: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "4px"
  },
  officerMeta: {
    fontSize: "12px",
    lineHeight: 1.55,
    color: "#64748b"
  },
  emptyState: {
    padding: "42px 24px",
    textAlign: "center",
    backgroundColor: "#ffffff"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    margin: "0 auto 14px auto",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
    color: "#2563eb",
    fontSize: "26px"
  },
  emptyTitle: {
    margin: 0,
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 800
  },
  emptyText: {
    margin: "10px auto 0 auto",
    color: "#64748b",
    fontSize: "14px",
    lineHeight: 1.6
  }
};

class SurveyFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      route: [{ url: "", name: "Task Management" }],
      route1: [{ url: "", name: "Contract Management" }],
      appTasklist: [],
      user: {},
    };
  }

  async componentDidMount() {
    let user = auth.getCurrentUser();
    if (user?.id > 0) {
      const { data: appliedApplication } = await http.get(
        config.GetPerformerApplication + user.id
      );

      if (appliedApplication.length > 0) {
        const filterApp = appliedApplication.filter(
          (x) => x.workflowType === 2 && x.type !== "Background Check"
        );
        let appTasklist = [];
        filterApp.map(async (item) => {
          const { data: runningApplication } = await http.get(
            config.GetRunningTask + item.workflowId + "&performerId=" + user.id
          );
          const obj = {
            chkApp: item,
            runningApplication,
          };
          appTasklist.push(obj);
          this.setState({ appTasklist, user });
        });
      }
    }
  }

  handleCurrentTask = async (wiid) => {
    const { data: workflowTask } = await http.get(
      config.GetWorkflowTask + wiid
    );
    if (workflowTask.formId > 0) {
      if (workflowTask.formType === "CF") {
        this.props.history.push({
          pathname: "/" + workflowTask.formName,
          state: { workflowTask },
        });
      } else {
        this.props.history.push({
          pathname: "/DynamicForm",
          state: { workflowTask },
        });
      }
    }
  };

  render() {
    const { route, appTasklist, user, route1 } = this.state;
    const usrType = localStorage.getItem("userType");
    const totalSurveyGroups = appTasklist.length;
    const totalSurveyTasks = appTasklist.reduce((count, app) => count + ((app.runningApplication || []).length), 0);
    const actionableTasks = appTasklist.reduce(
      (count, app) => count + (app.runningApplication || []).filter((item) => parseInt(user.id) === item.performerId).length,
      0
    );
    return (
      <React.Fragment>
        <div className="col-md-12 form-group" style={SURVEY_STYLES.pageWrap}>
          <div style={SURVEY_STYLES.shell}>
            <div style={SURVEY_STYLES.hero}>
              <div style={SURVEY_STYLES.heroRow}>
                <div style={SURVEY_STYLES.titleWrap}>
                  <div style={SURVEY_STYLES.titleIcon}>
                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                  </div>
                  <div style={SURVEY_STYLES.titleCopy}>
                    <h1 style={SURVEY_STYLES.title}>Survey Feedback</h1>
                    <p style={SURVEY_STYLES.subtitle}>
                      Review survey-related workflow tasks, open any steps assigned to you, and keep track of reviewer follow-up in one place.
                    </p>
                  </div>
                </div>
                <div style={SURVEY_STYLES.soonBadge}>
                  <i className="fa fa-bullhorn" aria-hidden="true"></i>
                  Complete Your Surveys Coming Soon
                </div>
              </div>
              <div style={SURVEY_STYLES.statsRow}>
                <div style={SURVEY_STYLES.statCard}>
                  <div style={SURVEY_STYLES.statLabel}>Survey Groups</div>
                  <div style={SURVEY_STYLES.statValue}>{totalSurveyGroups}</div>
                  <div style={SURVEY_STYLES.statHint}>Survey-related application groups available to review.</div>
                </div>
                <div style={SURVEY_STYLES.statCard}>
                  <div style={SURVEY_STYLES.statLabel}>Total Tasks</div>
                  <div style={SURVEY_STYLES.statValue}>{totalSurveyTasks}</div>
                  <div style={SURVEY_STYLES.statHint}>Workflow tasks currently shown across all survey groups.</div>
                </div>
                <div style={SURVEY_STYLES.statCard}>
                  <div style={SURVEY_STYLES.statLabel}>Actionable</div>
                  <div style={SURVEY_STYLES.statValue}>{actionableTasks}</div>
                  <div style={SURVEY_STYLES.statHint}>Tasks that can be opened directly by your current user.</div>
                </div>
              </div>
            </div>

            <div style={SURVEY_STYLES.body}>
              {appTasklist.length > 0 ? appTasklist.map((app, appIndex) => (
                <div key={app.chkApp?.workflowId || appIndex} style={SURVEY_STYLES.sectionCard}>
                  <div style={SURVEY_STYLES.sectionHeader}>
                    <div>
                      <h3 style={SURVEY_STYLES.sectionTitle}>Complete Survey(s)</h3>
                      <div style={SURVEY_STYLES.sectionMeta}>
                        {(app.runningApplication || []).length} workflow task{(app.runningApplication || []).length === 1 ? "" : "s"} available in this survey group.
                      </div>
                    </div>
                    <div style={SURVEY_STYLES.sectionBadge}>{(app.runningApplication || []).length}</div>
                  </div>
                  <div className="table-responsive">
                    <table className="table align-items-center table-hover mb-0" style={{ marginBottom: 0 }}>
                      <thead>
                        <tr>
                          <th style={SURVEY_STYLES.tableHeadCell}></th>
                          <th style={SURVEY_STYLES.tableHeadCell}>Date</th>
                          <th style={SURVEY_STYLES.tableHeadCell}>Application Workflow Status</th>
                          <th style={SURVEY_STYLES.tableHeadCell}>Review Officer</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(app.runningApplication || []).map((item, key) => (
                          <tr key={item.wiid || key}>
                            <td style={SURVEY_STYLES.cell}>
                              <span style={SURVEY_STYLES.serialBadge}>{key + 1}</span>
                            </td>
                            <td style={SURVEY_STYLES.cell}>
                              <span style={SURVEY_STYLES.datePrimary}>
                                <Moment format="MMM Do YYYY">
                                  {item.startDateTime}
                                </Moment>
                              </span>
                              <span style={SURVEY_STYLES.dateSecondary}>
                                <Moment format="h:mm A">
                                  {item.startDateTime}
                                </Moment>
                              </span>
                            </td>
                            <td style={SURVEY_STYLES.cell}>
                              {parseInt(user.id) === item.performerId ? (
                                <Link
                                  to="#"
                                  style={SURVEY_STYLES.taskLink}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    this.handleCurrentTask(item.wiid);
                                  }}
                                >
                                  {item.taskName}
                                </Link>
                              ) : (
                                <span style={SURVEY_STYLES.officerName}>{item.taskName}</span>
                              )}
                            </td>
                            <td style={SURVEY_STYLES.cell}>
                              {parseInt(user.id) !== item.performerId ? (
                                <React.Fragment>
                                  {item.performer !== null && (
                                    <div style={SURVEY_STYLES.officerName}>{item.performer.toUpperCase()}</div>
                                  )}
                                  {item.email !== null && (
                                    <div style={SURVEY_STYLES.officerMeta}>Email: {item.email}</div>
                                  )}
                                  {item.contact !== null && (
                                    <div style={SURVEY_STYLES.officerMeta}>Contact: {item.contact}</div>
                                  )}
                                </React.Fragment>
                              ) : (
                                <span style={SURVEY_STYLES.officerMeta}>Assigned to you</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )) : (
                <div style={SURVEY_STYLES.emptyState}>
                  <div style={SURVEY_STYLES.emptyIcon}>
                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                  </div>
                  <h4 style={SURVEY_STYLES.emptyTitle}>No survey feedback tasks yet</h4>
                  <p style={SURVEY_STYLES.emptyText}>
                    Survey-related workflow tasks will appear here once they are assigned to your account.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SurveyFeedback;
